import { Inject, Injectable } from '@angular/core';
import { LogDocument, LogRepository } from '@infrab4a/connect';
import { BaseConnectService } from './base-connect.service';

@Injectable({
  providedIn: 'root'
})
export class ShopLoggingService extends BaseConnectService<LogDocument> {
  constructor(
    @Inject('LogRepository')
    private logRepository: LogRepository
  ) {
    super(logRepository);
  }

  async createBatchUpdateLog(
    collection: string,
    document: any,
    user: { id?: string; name: string; email?: string }
  ) {
    return this.logRepository.create({
      collection,
      date: new Date(),
      document,
      operation: 'UPDATE',
      user
    });
  }
}
